import { Box, Flex, Skeleton, SkeletonText } from "@chakra-ui/react";
import React from "react";

const SimpleProductCardSkeleton = () => {
  return (
    <Flex
      direction={{ base: "column", xl: "row" }}
      alignItems={"center"}
      gap={"8px"}
      flex={"none"}
      w={"fit-content"}
    >
      <Skeleton
        width={{ base: "full", xl: "128px" }}
        h={{ base: "auto", xl: "90px" }}
        aspectRatio={1.5 / 1}
        rounded={"4px"}
      />
      <Box textAlign={{ base: "center", md: "left" }} flex={1} w={"100px"}>
        <SkeletonText mt={"4px"} noOfLines={1} skeletonHeight={"16px"} />
        <SkeletonText
          mt={"8px"}
          w={"70%"}
          noOfLines={1}
          mx={{ base: "auto", xl: "0" }}
          skeletonHeight={"8px"}
        />
      </Box>
    </Flex>
  );
};

export default SimpleProductCardSkeleton;
